module.exports = __webpack_public_path__ + "static/media/vanessa-logo.afa118d6.png";